module.exports = __webpack_public_path__ + "static/img/アセット 46@3x.b807b69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 46@3x.jpg
// module id = WIgQ
// module chunks = 1